var exports = {
  "q": "AppLayout.module__appLayout___b3JBRk",
  "X": "AppLayout.module__appLayoutStandalone___b3JBRk",
};

module.exports = exports;
